var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{attrs:{"z-index":"99","custom-style":{backgroundColor:_vm.bgCloor},"show":_vm.show}},[_c('div',{staticClass:"wrapper"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }